interface FilterBarProps {
  options: string[];
  selected: string;
  onSelect: (value: string) => void;
  allLabel?: string;
}

export function FilterBar({ options, selected, onSelect, allLabel = 'Todos' }: FilterBarProps) {
  const allOptions = [allLabel, ...options];

  return (
    <div className="mb-6 flex flex-wrap gap-2">
      {allOptions.map((option) => {
        const isActive = selected === option || (option === allLabel && selected === '');
        return (
          <button
            key={option}
            onClick={() => onSelect(option === allLabel ? '' : option)}
            className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
              isActive
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
